import { type Plugin } from 'vue';
import Clarity from '@microsoft/clarity';

let initialize = false;

export function createClarity(projectId: string): Plugin {
  return {
    install() {
      if (projectId) {
        Clarity.init(projectId);
        initialize = true;
      }
    },
  };
}

export function useClarity() {
  if (!initialize) {
    console.warn('Initialize clarity before use');
    return undefined;
  }

  return Clarity;
}
